module.exports = __webpack_public_path__ + "static/media/banner.377f4d95.png";